import { Dispatch } from "react";

import restUrls from "web/constants/restUrls";

import { request } from "web/api";

import handleCodeSessionStorageAction, {
  CodeActionType,
} from "./handleCodeSessionStorageAction";

type GetCodeArgs = {
  itemId: number;
  setCode: Dispatch<React.SetStateAction<string | null>>;
};
type GetCodeFn = (args: GetCodeArgs) => void;

const getCode: GetCodeFn = async ({ itemId, setCode }) => {
  try {
    const response = await request(
      `${restUrls.productCode}?item_id=${Number(itemId)}`
    );
    const productCode = (response as { code: string }[])[0].code;
    handleCodeSessionStorageAction({
      itemId,
      action: CodeActionType.SET_CODE,
      value: productCode,
    });
    setCode(productCode);
  } catch (error) {
    console.error(error);
  }
};

export default getCode;
